import React from "react";
import MetaData_V2 from "../../Components_V2/MetaData/MetaData";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";
// import Packages from "../../Components/Packages/Packages";
// import Packages2 from "../../Components/Packages2/Packages2";
// import APIPackage from "../../Components/APIPackage/APIPackage";
import "./Pricing.css";
import Packages from "../../Components_V2/Packages/Packages";
import Packages2 from "../../Components_V2/Packages2/Packages2";
import APIPackage from "../../Components_V2/APIPackage/APIPackage";

const Pricing_V2 = () => {
  return (
    <div>
         <MetaData_V2
        pageTitle={
          "Best Generative AI Tool for Beginners | Easy Generative AI"
        }
        pageDescription={
          "Find the best generative AI tools for beginners to create text, images, audio, and more. Enjoy user-friendly platforms designed for easy learning and creativity."
        }
        canonical="https://whalesai.com/pricing"
      ></MetaData_V2>
      <PageHeading_V2 title="Pricing" />
      <section className="py-5" style={{ background: "#006c62" }}>
        <div className="container px-4">
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h2 className="method-heading text-uppercase text-white mb-3">
              Method 1
              <br /> Do it yourself
            </h2>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          >
          </div>
        </div>
      </section>
     
      <section className="py-5" style={{ background: "#006c62" }}>
        <div className="container px-4">
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h2 className="method-heading my-3 text-uppercase text-white">
              Method 2
              <br /> Let us do it for you
            </h2>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages2 />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          > 
          </div>
        </div>
      </section>


      <section className="py-5" style={{ background: "#006c62" }}>
        <div className="container px-4">
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h2 className="method-heading my-3 text-uppercase text-white">
            API PACKAGE 
              <br />
              <p >USD 5.00: 250 credits</p>
            </h2>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <APIPackage />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          >
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing_V2;
